import { Component } from 'react'
import PropTypes from 'prop-types'
import conf from '../../../../../shared/conf.js'

import consultant from './images/consultant.svg'
import company from './images/company.svg'

import './AccountTypeSelector.scss'

const accountTypes = conf.accountTypes
const types = Object.keys(conf.accountTypes).map((val) => conf.accountTypes[val])

class AccountTypeSelector extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOf(types)
  }

  static defaultProps = {
    onChange: () => {},
    value: types[0]
  }

  constructor(props) {
    super(props)

    this.state = {
      value: props.value
    }

    this.props.onChange(props.value)
  }

  selectConsultant = () => {
    if (this.state.value !== accountTypes.freelance) {
      this.props.onChange(accountTypes.freelance)
      this.setState({
        value: accountTypes.freelance
      })
    }
  }

  selectCompany = () => {
    if (this.state.value !== accountTypes.do) {
      this.props.onChange(accountTypes.do)
      this.setState({
        value: accountTypes.do
      })
    }
  }

  render() {
    return (
      <div className="account-type-selector">
        <div onClick={this.selectCompany} className={`register-card ${this.state.value === accountTypes.do ? 'active' : ''}`}>
          <div className="image">
            <img src={company} alt="Entreprise" />
          </div>
          <div className="label">Je cherche un profil</div>
        </div>
        <div onClick={this.selectConsultant} className={`register-card ${this.state.value === accountTypes.freelance ? 'active' : ''}`}>
          <div className="image">
            <img src={consultant} alt="Consultant" />
          </div>
          <div className="label">Je cherche une mission</div>
        </div>
      </div>
    )
  }
}


export default AccountTypeSelector